import { useRecoilState } from "recoil";
import { serviceNoAtom } from "src/atoms";

// 서비스 번호
export const useServiceNo = () => {
  const [serviceNo, setServiceNo] = useRecoilState(serviceNoAtom);

  return { serviceNo, setServiceNo };
};
